/* src/app/global/visualizacao/fragmentos/toastr-principal/toastr-principal.component.scss */
:host {
  position: fixed;
  top: 70px;
  right: 30px;
  z-index: 100000;
}
.toastr {
  position: relative;
  margin-bottom: 10px;
}
/*# sourceMappingURL=toastr-principal.component.css.map */
